module.exports = __webpack_public_path__ + "media/educators/promote-fastweb@2x-ad65cbf8.jpg";